import { ConfigurationSourceDataMap, CoordinatingGroup, Institution, MasterGroup, Metadata, Participant, SourceData, Trial } from "@/api/dtos";
import { useMemo } from "react";
import { createEvent } from "./useEvent";
import { createForm } from "./useForm";

export const createForms = (
    metadata?: Metadata, 
    trialConfiguration?: ConfigurationSourceDataMap, 
    configuration?: ConfigurationSourceDataMap, 
    sourceData?: SourceData,
    trial?: Trial, 
    masterGroup?: MasterGroup,
    coordinatingGroup?: CoordinatingGroup,
    institution?: Institution,
    participant?: Participant,
    studyEventOid?: string,
    studyEventRepeat?: number,
    preview?: boolean
) => {
    if (!studyEventOid || !metadata || !metadata.eventForms || !metadata.eventForms[studyEventOid]) {
        return undefined;
    }

    return (
        Object.keys(metadata.eventForms[studyEventOid]).map(caseReportFormOid => {
            return createForm(
                metadata, 
                trialConfiguration?.forms, 
                configuration?.forms,
                sourceData?.forms,
                trialConfiguration?.formVersions, 
                configuration?.formVersions,
                trial,
                masterGroup,
                coordinatingGroup,
                institution,
                participant,
                configuration?.configuration?.isGlobal,
                configuration?.configuration?.id, 
                studyEventOid,
                studyEventRepeat,
                caseReportFormOid
            );
        }) as Array<NonNullable<ReturnType<typeof createForm>>>
    )
    .filter(x => !!x)
    .sort((a, b) => a.eventFormMetadata?.order! < b.eventFormMetadata?.order! ? -1 : 1)
}

const useForms = (
    metadata?: Metadata, 
    trialConfiguration?: ConfigurationSourceDataMap, 
    configuration?: ConfigurationSourceDataMap, 
    sourceData?: SourceData,
    trial?: Trial, 
    masterGroup?: MasterGroup,
    coordinatingGroup?: CoordinatingGroup,
    institution?: Institution,
    participant?: Participant,
    studyEventOid?: string,
    studyEventRepeat?: number,
    preview?: boolean
) => {
    return useMemo(() => {
        return createForms(
            metadata, 
            trialConfiguration, 
            configuration,
            sourceData, 
            trial, 
            masterGroup,
            coordinatingGroup,
            institution,
            participant,
            studyEventOid,
            studyEventRepeat,
            preview
        );
    }, [
        metadata, 
        trialConfiguration?.forms, 
        configuration?.forms, 
        sourceData?.forms, 
        trialConfiguration?.formVersions, 
        configuration?.formVersions,
        trial, 
        institution,
        masterGroup, 
        coordinatingGroup, 
        participant, 
        studyEventOid,
        studyEventRepeat,
        preview
    ]) as Array<NonNullable<ReturnType<typeof createForm>>> | undefined
};

export default useForms;